import { Dispatch, FormEvent } from 'react'
import { Company, Document, Project, TemplateDocument, User } from './models'
export * from './models'

export interface Action {
  payload?: any
  type: string
}

export interface CompanyIdUrlParam {
  companyId: number
}

export interface ProjectIdUrlParam {
  projectId: number
}

export interface TemplateIdUrlParam {
  templateDocumentId: number
}

export interface TemplateSubDirectoryParam {
  templateSubDocumentId?: number | undefined
}

export interface ActionUrlParam {
  hideActions?: boolean
}

export interface TemplateUrlParam {
  isTemplate?: boolean
}

export interface ProjectRolesParam {
  companyId: number | undefined
  projectId: number | undefined
  templateDocumentId?: number | undefined
  projectUserType?: number | undefined
}

export interface ProjectRolesAndPermissionParam {
  projectUserType?: number | undefined
  projectPermissionType?: number | undefined
}

export type UrlParams = CompanyIdUrlParam & ProjectIdUrlParam
export type ActionParams = ActionUrlParam

export type State = {
  documents: Document[]
  templateDocuments: TemplateDocument[]
  projects: Project[]
  companies: Company[]
  errors: string[]
  notices: string[]
  user: User
  permissionsList: []
  stripeProducts: StripeProducts
  project_managers: []
  project_coordinators: []
  signatories: []
  folder_access: []
  sub_contractors: []
  super_foremans: []
  directories: []
}

export type Context = [State, ActionableDispatch]

export type ActionableDispatch = Dispatch<Action>

export type onFormSubmitable = FormEvent<HTMLFormElement>

export type onFormChangeable = any

export type AcceptedInviteUser = Pick<User, 'firstName' | 'lastName'> & {
  password: string
  passwordConfirmation: string
}
export interface Geometry {
  type: string
  x: number
  y: number
  height: number
  width: number
}

export interface Annotation {
  _destroy?: boolean
  notPersisted?: boolean
  selection: {
    mode: string
    showEditor: boolean
  }
  geometry: Geometry
  data: AnnotationData
}

export interface AnnotationData {
  text: string
  hasDocumentsFields: boolean
  id: number
  inputType: string
  oldId?: number
  pageNumber: number
  userId?: number
  isAutoFillDate?: boolean | undefined
}

export type AutocompleteableItem = {
  id: number | undefined
  value: string
  payload?: any
  // selectedFolder?:number[]
}

export type AutocompleteFilterItem = (
  item: AutocompleteableItem,
  query: string,
) => boolean

export type AutocompleteOnSelect = (
  item: AutocompleteableItem,
  selectedFolder?: number[],
) => () => void

export interface SignupErrorAggregate {
  status: string
  title: string
  detail: {
    [signUpInput: string]: string[]
  }
}

export interface SignupError {
  response: {
    data: {
      errors: SignupErrorAggregate[]
    }
  }
}

export interface LoginError {
  response: {
    data: string
  }
}

export interface IntlNumberCurrencyOptions {
  type: string
  currency: string
}

export type StripeProduct = {
  amount: number
  currency: string
  interval: string
  priceId: string
  productId: string
  productName: string
}

export type StripeProducts = StripeProduct[]

export interface NewCompanyFormInputProps {
  name: string
  paymentMethodId: string
  product: string
}

export interface NewCompanyFormValidationErrors {
  name?: string
  paymentMethodId?: string
  product?: string
}

export interface RevealingButtonProps {
  onClick: () => void
  name: string
  text: string
}

export type UserType =
  | 'Project Coordinator'
  | 'Company Manager'
  | 'Sub-contractor/Foreman'

export const userRoles = [
  { id: 1, name: 'Company Manager', url: 'company_manager_roles' },
  // { id:2, name:'Project Manager', url: 'project_manager_roles' },
  { id: 5, name: 'Project Coordinator', url: 'project_coordinator_roles' },
  // { id:3, name:'Super/Foreman', url: 'super_foreman_roles' },
  { id: 4, name: 'Sub-contractor/Foreman', url: 'sub_contractor_roles' },
]
